import { Box, HStack, VStack, Text, Card, Link } from "@chakra-ui/react"
import { ReactNode } from "react"
import { COMPANY_NAME, COMPANY_URL } from "@hydrologiq/shared/branding"

function LogoCard({ children }: { children: ReactNode }) {
  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="background">
      <VStack minWidth={{ base: "200px", md: "500px" }} gap={0}>
        <HStack
          width={"100%"}
          height="66px"
          background="linear-gradient(90deg, #39aed2 0%, #a170d9 100%)"
          borderRadius={"md"}
          border="1px solid #D0D0D0"
          borderBottomLeftRadius={0}
          borderBottomRightRadius={0}
          borderBottom="none"
          gap={0}
          justifyContent={"space-around"}
          color="white"
        >
          <Text fontWeight="semibold" fontSize="32px" letterSpacing="0.75px">
            Logiq
          </Text>
        </HStack>
        <Card.Root
          width="100%"
          bg="white"
          borderRadius="md"
          border="1px solid #D0D0D0"
          m={0}
          p={0}
          borderTopLeftRadius={0}
          borderTopRightRadius={0}
          borderTop="none"
          borderBottomLeftRadius={0}
          borderBottomRightRadius={0}
          borderBottom="none"
        >
          <Card.Body m={0} p={0}>
            <VStack align="stretch" width="100%" p={8}>
              {children}
            </VStack>
          </Card.Body>
        </Card.Root>
        <HStack
          width={"100%"}
          height="40px"
          background="linear-gradient(90deg, #39aed2 0%, #a170d9 100%)"
          borderRadius={"md"}
          border="1px solid #D0D0D0"
          borderTopLeftRadius={0}
          borderTopRightRadius={0}
          borderTop="none"
          letterSpacing="0.75px"
          justifyContent={"center"}
          gap={1}
          color="white"
          fontWeight={"semibold"}
        >
          <Text>Powered by</Text>
          <Link href={COMPANY_URL} target="_blank" variant="underline">
            {COMPANY_NAME}
          </Link>
        </HStack>
      </VStack>
    </Box>
  )
}

export default LogoCard
